import React from "react";
import styles from "./style.module.scss";
import logo from "../../../../assets/images/mashie-shield-with-text-white.png";
import DeprecatedBanner from "./utils/DeprecatedBanner";
import APIVersionDropdown from "./utils/APIVersionDropdown";
import SectionDropdown from "./utils/SectionDropdown";
import EndpointsList from "./utils/EndpointsList";
import Endpoints from "./utils/Endpoints";
import GETCoursesIdAvailability from "./courses/GETCoursesIdAvailability.json";
import GETCoursesIdPriceList from "./courses/GETCoursesIdPriceList.json";
import GETCoursesIdQuote from "./courses/GETCoursesIdQuote.json";

const specs = [
    GETCoursesIdAvailability,
    GETCoursesIdPriceList,
    GETCoursesIdQuote,
];

export default function Index() {
    return (
        <div className='app events' style={{ paddingBottom: "100px" }}>
            <div className={styles.fullHeader} alt='event'>
                <img className={styles.entityLogo} src={logo} alt='logo' />
                <h1 className={styles.headerText}>
                    Golf Courses Documentation (v2)
                </h1>
            </div>
            <div className='container'>
                <APIVersionDropdown version='v2' />
                <SectionDropdown page='courses' />
                <div className='row'>
                    <div className='col-12'>
                        <h2>About this API</h2>
                        <p>
                            This API allows you to find golf courses pricing and
                            availability & get quotes for bookings
                        </p>
                        <div className={styles.spacer} />

                        <h2>Major updates since v1</h2>

                        <p>
                            <strong>DATA CHANGE</strong> - Golf clubs courses
                            have an entirely new pricing schema. Historically,
                            we only provided prices for summer and winter,
                            monday to sunday, with am and pm for the type of
                            member passed in. We now provide pricing information
                            for each month of the year, each day of the week,
                            every hour of the day, for the type of member passed
                            in. This gives significantly better pricing
                            flexibility for an entire year.
                            <ul>
                                <li>
                                    OLD: [summer/winter] &gt;
                                    [monday/tuesday/wednesday/thursday/friday/saturday/sunday]
                                    &gt; [am/pm]
                                </li>
                                <li>
                                    NEW: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10 ,11, 12]
                                    &gt; [1, 2, 3, 4, 5, 6, 7] &gt; [0, 1, 2, 3,
                                    4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
                                    16, 17, 18, 19, 20, 21, 22, 23]
                                </li>
                            </ul>
                        </p>
                        <p>
                            <strong>DATA CHANGE</strong> - Due to the change in
                            pricing structure, and new complexity of the data,
                            we have removed some helper data from the courses
                            relating to snapshot AM & PM pricing and poa
                            information. We have replaced this with 'lowest'
                            pricing for the timeslots available to the member.
                            This is due to the fact we now offer monthly, daily,
                            hourly pricing; meaning the snapshot information is
                            may no longer be relevant when displaying over
                            longer periods of time. If you still wish to get
                            this information, you can do so by doing an
                            availability or quote endpoint call which will
                            return daily pricing or a specific hour price as you
                            require.
                        </p>
                    </div>
                    <div className='col-12'>
                        <div className={styles.spacer} />
                        <h2>Endpoints</h2>
                        <EndpointsList specs={specs} />
                        <div className={styles.spacer} />
                        <Endpoints specs={specs} />
                    </div>
                </div>
            </div>
            <DeprecatedBanner version='v2' />
        </div>
    );
}
